module.exports = {
      id: "crash900 index-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite-dd6387.smartcharts.svg#crash900 index-usage",
      toString: function () {
        return this.url;
      }
    }